var map = {
	"./approval-gray.svg": "2462",
	"./approval.svg": "d78e",
	"./chiesi-logo.svg": "1ce5",
	"./database-lock-gray.svg": "cbe9",
	"./database-lock.svg": "090c",
	"./patient-enrollment-gray.svg": "3f03",
	"./patient-enrollment.svg": "933c",
	"./publication-gray.svg": "84a4",
	"./publication.svg": "1d61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";